<template>
  <div class="lodgingshow-entire" :class="isPhone ? 'mx-0' : ''">
    <RoomGalleryModal
      v-if="showRoomGalery"
      :item="this.lodging"
      @close="showRoomGalery = !showRoomGalery"
    />
    <div class="d-flex w-100 justify-content-between" :class="isPhone ? 'flex-column' : 'align-items-end mb-2'">
      <div class="d-flex flex-column">
        <h2 class="mb-2" :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-24'">{{ lodging.is_entire ? 'Le logement' : (lodging.lodging_description && lodging.lodging_description.rooms_description  && lodging.lodging_description.rooms_description != 'null' && lodging.lodging_description.rooms_description != 'undefined' ? lodging.lodging_description.rooms_description : 'Les chambres') }}</h2>
        <h3 :class="isPhone ? 'merriweather-light-18' : 'merriweather-light-20 mb-0'" v-if="lodging.is_entire">Logement pour {{lodging.accommodation_capacity}} voyageurs - {{ lodging.rooms.length }} chambre{{ lodging.rooms.length > 1 ? 's' : '' }}</h3>
        <h3 v-if="!lodging.is_entire" :class="isPhone ? 'merriweather-light-18' : 'merriweather-light-20 mb-0'">Choisissez votre évasion éco-chic.</h3>
        <div class="rooms-no-found d-flex align-items-baseline justify-content-center" :class="isPhone ? '' : 'mt-2'" v-if="!isPhone && !lodging.is_entire && !hasAvailableRooms && !isSearching">
          <div class="icon-exclamation mb-0"><p class="raleway-medi-p8">!</p></div>
          <p v-if="!hasAvailableRooms" class="mb-0 ml-1 mt-1" :class="[isPhone ? 'ml-1' : '', this.checkInIsCurrentDate ? 'raleway-reg-p13' : 'raleway-reg-p11']" style="color: #D56A70;">{{ this.checkInIsCurrentDate ? "Veuillez sélectionner des dates pour voir les disponibilités et les tarifs de cet établissement." : "Ce logement n'est pas disponible aux dates sélectionnées. Essayez d'autres dates pour vérifier les disponibilités." }}</p>
        </div>
      </div>
      <div class="d-flex" :class="isPhone ? 'mb-2' : ''" v-if="this.lodging.is_entire">
        <img src="../../images/accommodation_capacity.png" style="width: 24px; height:24px;" v-set-alt
          v-if="this.lodging.accommodation_capacity">
        <p class="raleway-reg-p15 mb-0 d-flex align-items-end" v-if="this.lodging.accommodation_capacity"> {{
          this.lodging.accommodation_capacity
        }}</p>
        <img src="../../images/bedroom.png" v-set-alt style="width: 24px; height:24px; margin-left: 20px;"
          v-if="this.lodging.number_of_room">
        <p class="raleway-reg-p15 mb-0 d-flex align-items-end" style="padding-left: 4px; font-size: 18px;"
          v-if="this.lodging.number_of_room"> {{
            this.lodging.number_of_room }}</p>
        <img src="../../images/bath.png" v-set-alt style="width: 22px; height:22px; margin-left: 20px;"
          v-if="this.lodging.number_of_bathroom">
        <p class="raleway-reg-p15 mb-0 d-flex align-items-end" style="padding-left: 5px; font-size: 18px;"
          v-if="this.lodging.number_of_bathroom">
          {{ this.lodging.number_of_bathroom }}</p>
      </div>
      <div class="galerie ml-3 text-nowrap" v-if="!isPhone">
        <img src="../../images/Galerie icone.svg" v-set-alt />
        <button style="color:white" class="link-hortense" @click="showRoomGalery = !showRoomGalery">Voir la Galerie</button>
      </div>
    </div>
    <div class="d-flex flex-column">
      <h4 v-if="showNoIcal && !lodging.event_lodging" style="color: #D56A70;" class="raleway-reg-p14">La réservation pour cet hébergement s’effectue sur demande. Votre séjour sera confirmé par l’hôte sous 24 heures maximum.</h4>
      <p :class="isPhone ? 'raleway-reg-p13' : 'raleway-reg-p15'" v-if="minNightsNew && minNightsNew > 0 && !lodging.is_entire">Nombre de nuits minimum : {{ minNightsNew }}</p>
    </div>
    <LodgingInfo v-if="isPhone && !lodging.event_lodging" :lodging="lodging" />
    <div class="rooms-no-found d-flex align-items-baseline justify-content-center" :class="isPhone ? '' : 'mt-2'" v-if="isPhone && !lodging.is_entire && !hasAvailableRooms && !isSearching">
      <div class="icon-exclamation mb-0"><p class="raleway-medi-p8">!</p></div>
      <p v-if="!hasAvailableRooms" class="mb-0 ml-1 mt-1" :class="[isPhone ? 'ml-1' : '', this.checkInIsCurrentDate ? 'raleway-reg-p13' : 'raleway-reg-p11']" style="color: #D56A70;">{{ this.checkInIsCurrentDate ? "Veuillez sélectionner des dates pour voir les disponibilités et les tarifs de cet établissement." : "Ce logement n'est pas disponible aux dates sélectionnées. Essayez d'autres dates pour vérifier les disponibilités." }}</p>
    </div>
    <!-- Booking Form -->
    <div class="booking-form-container" :class="[isPhone ? 'order-2' : '', 'villa-lodging-container']" v-if="lodging.is_entire">
      <!-- <div v-if="!isVillaLodging" class="w-100 d-flex flex-column booking-info-text" :class="isPhone ? 'mb-3' : 'mb-4'">
        <p :class="isPhone ? 'raleway-reg-p20' : 'raleway-reg-p20'">Sélectionnez les dates de votre évasion éco-chic</p>
        <p :class="isPhone ? 'raleway-reg-p13' : 'raleway-reg-p15'" style="color: #707070;">Ajoutez vos dates de séjour pour connaître le tarif exact</p>
        <p :class="isPhone ? 'raleway-bold-p13' : 'raleway-bold-p15'" v-if="minNightsNew && minNightsNew > 0">Nombre de nuits minimum : {{ minNightsNew }}</p>
        <p class="raleway-semi-p13 mb-0" style="color: #3B6152;">Notre service de conciergerie est disponible pour vous accompagner dans l'organisation de votre séjour. Nous sommes disponibles du lundi au vendredi de 9h à 18h (heure locale) : <a :href="`tel:+33626203846`" class="link-hortense" style="color: #3B6152;">+ 33 6 26 20 38 46.</a></p>
        <div class="booking-form">
          <div class="booking-header mt-3" v-if="isPhone">
            <div class="date-selector row w-100 px-3">
              <div class="date-block col-md-6 col-6 px-0">
                <div class="date-info w-100" @click="openCalendar">
                  <div class="label text-green raleway-semi-p15">Arrivée</div>
                  <div class="value pl-2 pt-2">{{ arrivalDate || 'Quand ?' }}</div>
                </div>
              </div>

              <div class="date-block date-block-2 col-md-6 col-6 px-0">
                <div class="date-info w-100" @click="openCalendar">
                  <div class="label text-green raleway-semi-p15">Départ</div>
                  <div class="value pl-2 pt-2">{{ departureDate || 'Quand ?' }}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!isPhone && false" style="margin-top: 1rem;" ref="datePickerContainer">
            <CommonDatePicker 
              :startingDateValue="disstartDate" 
              :endingDateValue="disendDate" 
              :startDate="minDate"
              :endDate="maxDate" 
              datePickerClass="lodging-entire-datepicker d-flex h-100 justify-content-center" 
              ref="datePickerHotel"
              @periodSelected="newSelectDates" 
              @datepickerClosed="submitAndClose" 
              :alwaysVisible="true"
              :hideClose="true"
            />
          </div>
          <div v-if="showCalendar && isPhone" style="margin-top: 1rem; display: none;" ref="datePickerContainertwo">
            <CommonDatePicker :startingDateValue="disstartDate" :endingDateValue="disendDate" :startDate="minDate"
              :endDate="maxDate" ref="datePickerHotel" @periodSelected="newSelectDates"
              @datepickerClosed="submitAndClose" :autoHide="false" :showCloseButton="true"
              :closeButtonText="'RECHERCHER'" />
          </div>
          <div class="d-flex justify-content-center booking-form-btn-container">
            <button 
              id="entire_booking" 
              class="hortense-btn-primary"
              :class="!isAvailable ? 'hortense-btn-disabled' : ''"
              @click="checkIfAvailable(startDate, endDate, guestNumber)" 
              :disabled="isSearching" 
              v-if="!isPhone && !isAvailable"
            >
              {{ !isAvailable ? 'LOGEMENT INDISPONIBLE' : availabilitySearchButtonCaption }}
            </button>
          </div>  
          <div class="d-flex align-items-baseline justify-content-center" :class="isPhone ? '' : 'mt-2'" v-if="!isAvailable">
            <div class="icon-exclamation mb-0"><p class="raleway-medi-p8">!</p></div>
            <p v-if="!isAvailable" class="mb-0 ml-1 raleway-reg-p11 mt-2" :class="isPhone ? 'ml-1' : ''" style="color: #D56A70;">Ce logement n’est pas disponible aux dates sélectionnées. Essayez d’autres dates pour vérifier les disponibilités.</p>
          </div>
        </div>
      </div> -->
      <!-- <hr :class="isPhone ? '' : 'mt-5'" v-if="((availabilitiesNotKoedia && availabilitiesNotKoedia.length > 0) || (roomOptions && roomOptions.length > 0)) && !isVillaLodging" /> -->
      <p style="color: #D56A70;" :class="isPhone ? 'raleway-reg-p13' : 'raleway-reg-p15'" v-if="minNightsNew && minNightsNew > 0">Nombre de nuits minimum : {{ minNightsNew }}</p>
      <!-- Reservation Cards in Single Column -->
      <div class="reservation-cards-container" v-if="showReservationCards && isAvailable">
        <template v-if="show_resa_card && !isSearching && lodging.is_entire && !accommodation_code">
          <ReservationCard
            :minNights="minNights"
            :minNightsNew="minNightsNew"
            :accomodationCode="accommodation_code"
            :searched="searched"
            :isSearching="isSearching"
            :item="lodging"
            :from="from"
            :to="to"
            :koediaFrom="koediaFrom"
            :koediaTo="koediaTo"
            :roomAvailability="roomOptions"
            :roomAvailabilityNotKoedia="availabilitiesNotKoedia"
            :tariffsNotKoedia="tariffsNotKoedia"
            :isEntire="true"
            :taxNotKoedia="lodgingTax"
            :nights="nights"
            :taxTotal="touristTax"
            @sendInfo="displayUserInfo"
            @open-guest-modal="openGuestModal"
            :lodging="lodging"
            @open-modal="handleShowModal"
            @open-login-modal="openLoginModal"
            :hideMinNightsMessage="true"
            :isVillaLodging="isVillaLodging"
            :user="user"
            :adults="adults"
            :childAges="selectedChildAges"
            class="single-column-card"
          />
        </template>

        <template v-if="show_resa_card && !isSearching && lodging.is_entire && accommodation_code">
          <ReservationCard
            :minNights="minNights"
            :minNightsNew="minNightsNew"
            :accomodationCode="accommodation_code"
            :searched="searched"
            :isSearching="isSearching"
            :item="lodging"
            :from="from"
            :to="to"
            :roomAvailability="roomOptions"
            :roomAvailabilityNotKoedia="availabilitiesNotKoedia"
            :tariffsNotKoedia="tariffsNotKoedia"
            :isEntire="true"
            :taxNotKoedia="lodgingTax"
            :nights="nights"
            :taxTotal="touristTax"
            @sendInfo="displayUserInfo"
            @open-guest-modal="openGuestModal"
            :lodging="lodging"
            :koediaFrom="koediaFrom"
            :koediaTo="koediaTo"
            :koediaSessionId="koediaSessionId"
            @open-modal="handleShowModal"
            @open-login-modal="openLoginModal"
            :hideMinNightsMessage="true"
            :isVillaLodging="isVillaLodging"
            :user="user"
            :adults="adults"
            :childAges="selectedChildAges"
            class="single-column-card"
          />
        </template>
      </div>
      <div v-else class="villa-layout-container">
        <div class="no-villa-container">
          <p class="raleway-reg-p15 d-flex w-100 h-100 justify-content-center align-items-center text-center" style="color: #D56A70;">{{ !startDate && !endDate ? "Sélectionnez vos dates de séjour pour vérifier les disponibilités de cet hébergement." : "Ce logement n'est pas disponible aux dates sélectionnées. Essayez d'autres dates pour vérifier les disponibilités." }}</p>
        </div>
        <VillaInfoContainer :noVilla="true" />
      </div>
    </div>
   
  </div>
</template>

<script>
import ReservationCard from "../../components/cards/ReservationCard";
import fetcher from "../../packs/shared/api.js";
import LodgingInfo from "../../components/lodgings/LodgingInfo";
import RoomGalleryModal from "../../components/modals/RoomGalleryModal.vue";
import VillaInfoContainer from "../../components/cards/VillaInfoContainer.vue";
import { timers } from "jquery";
import { ensureOspitaTrackingId, resolveReservationEventName, withOspitaTrackingId } from "../../utils/reservationFlow";

export default {
  name: "LodgingshowEntire",
  components: {
    ReservationCard,
    LodgingInfo,
    RoomGalleryModal,
    VillaInfoContainer
  },
  props: {
    lodging: {
      type: Object,
      required: true,
    },
    user: Object,
    adults: {
      type: Number,
      required: false,
      default: 2,
    },
    initialChildAges: {
      type: Array,
      required: false,
      default: () => ([]),
    },
  },
  data() {
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);
    
    return {
      // Date and guest data
      showRoomGalery: false,
      arrivalDate: this.newFormatDate(today),
      departureDate: this.newFormatDate(tomorrow),
      children: 0,
      selectedChildAges: Array.isArray(this.initialChildAges) ? [...this.initialChildAges] : [],
      guestNumber: this.lodging.accommodation_capacity || 2,
      
      // UI state
      showCalendar: false,
      showTravelerDropdown: false,
      showReservationCards: false,
      
      // Date picker data
      disstartDate: null,
      disendDate: null,
      startDate: null,
      endDate: null,
      minDate: new Date(),
      maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 2)),
      
      // Availability data - managed internally
      minNights: null,
      minNightsNew: null,
      accommodation_code: null,
      searched: false,
      isSearching: false,
      show_resa_card: false,
      roomOptions: null,
      availabilitiesNotKoedia: [],
      lodgingTax: null,
      nights: null,
      touristTax: null,
      koediaSessionId: null,
      from: null,
      to: null,
      koediaFrom: null,
      koediaTo: null,
      hasAvailableRooms: true,
    };
  },
  computed: {
    isVillaLodging() {
      return this.lodging.type && (this.lodging.type === 'Maison et Villa') || (this.lodging.type === 'Chalet') && this.lodging.is_entire;
    },
    showNoIcal() {
      const rooms = Array.isArray(this.lodging?.rooms) ? this.lodging.rooms : [];
      const allRoomsMissingIcal = rooms.length > 0
        ? rooms.every((room) => !room.ical_url || room.ical_url === '')
        : true;

      return !this.accommodation_code && (
        (this.lodging.is_entire && (!this.lodging.ical_url || this.lodging.ical_url === '')) ||
        (!this.lodging.is_entire && allRoomsMissingIcal)
      );
    },
    isPhone() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
    },
    isAvailable() {
      if (this.accommodation_code) {
        return this.roomOptions && this.roomOptions.length > 0;
      } else {
        return this.tariffsNotKoedia && this.tariffsNotKoedia.length > 0;
      }
    },
    availabilitySearchButtonCaption() {
      if (this.isSearching) {
        return "Recherche en cours...";
      } else {
        return "Vérifier les disponibilités";
      }
    },
    tariffsNotKoedia() {
      if (!this.availabilitiesNotKoedia || this.availabilitiesNotKoedia.length === 0) {
        return [];
      }

      const data = this.availabilitiesNotKoedia;

      // Step 1: Build { tariff: Set(unique_dates) }
      const tariffDateMap = {};

      data.forEach(item => {
        if (item.tariff && item.tariff !== "") {
          if (!tariffDateMap[item.tariff]) {
            tariffDateMap[item.tariff] = new Set();
          }
          tariffDateMap[item.tariff].add(item.date);
        }
      });

      // Step 2: Filter tariffs that exist for all nights
      // For event lodgings, the response only contains night records (no checkout date record),
      // so expected count is exactly `nights`. For normal lodgings it is `nights + 1`.
      const expectedDayCount = this.lodging.event_lodging ? this.nights : this.nights + 1;

      const validTariffs = Object.keys(tariffDateMap).filter(tariff => {
        return tariffDateMap[tariff].size === expectedDayCount;
      });

      // Step 3: Filter by guest count (tN tokens in tariff string)
      const guestCount = this.getSelectedGuestCount();

      return validTariffs.filter(tariff => {
        const tokens = String(tariff).split(',').map(t => t.trim());
        const guestToken = tokens.find(t => /^t\d+$/i.test(t));
        if (!guestToken) return true; // no guest constraint — always valid
        const required = parseInt(guestToken.replace(/^t/i, ''), 10);
        return Number.isFinite(required) ? guestCount === required : true;
      });
    },
    checkInIsCurrentDate() {
      if (!this.from || !this.to) {
        return false 
      }
      return this.formatDateKoedia(new Date()) === this.from && this.formatDateKoedia(new Date(new Date().setDate(new Date().getDate() + 1))) === this.to;
    },
  },
  methods: {
    openCalendar() {
      if (!this.isPhone) return;
      const bookingForm = this.$el.querySelector('.booking-form');
      if (!bookingForm) return;
      const datepickerWrapper = bookingForm.querySelector('.vhd__datepicker');
      if (datepickerWrapper) {
        datepickerWrapper.style.display = 'block';
      }

      this.showCalendar = true;

      this.$nextTick(() => {
        if (this.$refs.datePickerContainertwo) {
          this.$refs.datePickerContainertwo.style.display = 'block';
          if (this.isPhone) {
            this.$refs.datePickerHotel.showDatepicker();
          }
        }
      });
    },
    newFormatDate(date) {
      if (!date) return '';
      const options = { day: 'numeric', month: 'short', year: 'numeric' };
      return date.toLocaleDateString('fr-FR', options).toUpperCase().replace(/\./g, '');
    },
    increase(type) {
      this[type]++;
    },
    decrease(type) {
      if (this[type] > 0) this[type]--;
    },
    toggleTravelerDropdown() {
      this.showTravelerDropdown = !this.showTravelerDropdown;
    },
    newSelectDates(event, start, end) {
      this.startDate = this.formatDate(start);
      this.endDate = this.formatDate(end);
      this.disstartDate = start;
      this.disendDate = end;
      this.koediaFrom = this.formatDateKoedia(this.startDate);
      this.koediaTo = this.formatDateKoedia(this.endDate);
      this.from = this.koediaFrom;
      this.to = this.koediaTo;

      if (start && end) {
        this.arrivalDate = this.formatDate2(start);
        this.departureDate = this.formatDate2(end);
      }

      // Save to localStorage
      const state = withOspitaTrackingId({
        koediaFrom: this.koediaFrom,
        koediaTo: this.koediaTo,
        from: this.koediaFrom,
        to: this.koediaTo,
        adults: this.adults,
        childs: this.children,
        children_ages: this.selectedChildAges,
      });
      localStorage.setItem('reservationState', JSON.stringify(state));
      this.$emit('datesUpdated');
    },
    submitAndClose() {
      this.showCalendar = false;
      this.checkIfAvailable(this.startDate, this.endDate, this.guestNumber);
    },
    formatDate(date) {
      if (!date) return null;
      const set = new Date(date);
      const options = { year: "numeric", month: "numeric", day: "numeric" };
      return set.toLocaleString("fr", options);
    },
    formatDateKoedia(date) {
      if (!date) return null;
      if (typeof date === 'object' && date instanceof Date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
      if (typeof date === 'string' && date.includes('-')) return date;
      if (typeof date === 'string') {
        const dateBits = date.split('/');
        return dateBits.length === 3 ? `${dateBits[2]}-${dateBits[1]}-${dateBits[0]}` : date;
      }
      return null;
    },
    formatDate2(date) {
      if (!date) return '';

      const monthsFR = [
        'JANV.', 'FEV.', 'MARS', 'AVR.', 'MAI', 'JUIN',
        'JUIL.', 'AOÛT', 'SEPT.', 'OCT.', 'NOV.', 'DEC.'
      ];

      const day = date.getDate();
      const month = monthsFR[date.getMonth()];
      const year = date.getFullYear();

      return `${day} ${month} ${year}`;
    },
    getSelectedGuestCount() {
      const adults = Number.parseInt(this.adults, 10);
      const safeAdults = Number.isFinite(adults) && adults > 0 ? adults : 2;
      const childCountFromState = Number.parseInt(this.children, 10);
      const safeChildren = Number.isFinite(childCountFromState) && childCountFromState >= 0
        ? childCountFromState
        : Array.isArray(this.selectedChildAges) ? this.selectedChildAges.filter((age) => age !== null && age !== undefined && age !== '').length : 0;

      return safeAdults + safeChildren;
    },
    async ReqInventoryBook() {
      try {
        const res = await fetcher.post(
          `/lodgings/${this.lodging.slug}/request_inventory_booking`,
          {
            start: this.koediaFrom,
            end: this.koediaTo,
          }
        );
        if (res.data) {
          this.minNights = res.data.booking_request;
        }
      } catch (e) {
        console.error(e);
      }
    },
    getAvailability(checkin, checkout, guests) {
      return fetcher.post(`/lodgings/${this.lodging.slug}/get_availability`, {
        accommodation_code: this.accommodation_code,
        start: this.formatDateKoedia(checkin),
        end: this.formatDateKoedia(checkout),
        adults: this.adults || guests || 2,
        children: this.children,
        children_ages: this.selectedChildAges,
        ospita_tracking_id: ensureOspitaTrackingId(),
      });
    },
    countNights() {
      let from = this.toDate(this.koediaFrom);
      let to = this.toDate(this.koediaTo);
      
      if (from && to) {
        this.nights = Math.ceil((to - from) / (1000 * 60 * 60 * 24));
      } else {
        this.nights = 0;
      }
    },
    toDate(date) {
      let d = new Date(date);
      d.setHours(12, 0, 0, 0);
      return d;
    },
    extractNightRequirement(tariff) {
      if (!tariff) return null;
      const nightMatch = tariff.match(/n(\d+)/);
      return nightMatch ? parseInt(nightMatch[1], 10) : null;
    },
    hasMultipleTariffsForSameDate(filteredData) {
      // Group items by date and count unique tariffs per date
      const tariffsByDate = {};
      filteredData.forEach(item => {
        if (!tariffsByDate[item.date]) {
          tariffsByDate[item.date] = new Set();
        }
        if (item.tariff) {
          tariffsByDate[item.date].add(item.tariff);
        }
      });
      
      // Check if any date has multiple different tariffs
      return Object.values(tariffsByDate).some(tariffSet => tariffSet.size > 1);
    },
    matchesTariffNightRequirement(item, hasMultipleTariffs) {
      const requiredNights = this.extractNightRequirement(item.tariff);
      if (requiredNights === null) {
        return true;
      }
      // Only do exact night comparison if there are multiple tariffs for same date
      if (!hasMultipleTariffs) {
        return true;
      }
      return this.nights === requiredNights;
    },
    async updateAvailabilityInfo() {
      if (this.startDate && this.endDate) {
        this.from = this.koediaFrom;
        this.to = this.koediaTo;
      }
      await this.countNights();
      this.isSearching = false;
      this.searched = true;
      this.touristTax = (parseFloat(this.lodging.tax.tourist_tax) *
        parseInt(this.nights) *
        parseInt(this.guestNumber)).toFixed(2);
    },
    async checkIfAvailable(checkin, checkout, guests) {
      this.searched = false;
      this.isSearching = true;
      this.show_resa_card = false;
      this.showReservationCards = true;

      if (!this.accommodation_code) {
        // Non-Koedia availability
        await this.countNights();
        this.availabilitiesNotKoedia = [];
        
        try {
          const response = await fetcher.post('/lodgings/' + this.lodging.id + '/availabilities');

          // For event lodgings, derive checkin/checkout from the min/max dates in the response
          if (this.lodging.event_lodging && response.data && response.data.length > 0) {
            const validDates = response.data
              .filter(item => item.date)
              .map(item => item.date);
            if (validDates.length > 0) {
              const minDate = validDates.reduce((a, b) => (a < b ? a : b));
              const maxDate = validDates.reduce((a, b) => (a > b ? a : b));
              // Checkout is the day after the last availability date (each date = one night)
              const checkoutDate = new Date(maxDate);
              checkoutDate.setDate(checkoutDate.getDate() + 1);
              const checkoutDateStr = this.formatDateKoedia(checkoutDate);
              this.startDate = this.formatDate(minDate);
              this.endDate = this.formatDate(checkoutDateStr);
              this.koediaFrom = minDate;
              this.koediaTo = checkoutDateStr;
              this.from = minDate;
              this.to = checkoutDateStr;
              await this.countNights();
              // Persist event-derived dates to localStorage so confirmation page uses correct range
              const eventState = JSON.parse(localStorage.getItem('reservationState') || '{}');
              localStorage.setItem('reservationState', JSON.stringify(withOspitaTrackingId({
                ...eventState,
                koediaFrom: minDate,
                koediaTo: checkoutDateStr,
                from: minDate,
                to: checkoutDateStr,
              })));
              // Notify parent (Lodgingshow.vue) to sync its own koediaFrom/koediaTo from localStorage.
              // Pass noScroll=true so the parent does not scroll on auto-detection.
              this.$emit('datesUpdated', { noScroll: true });
            }
          }

          let availabilityStartDate = this.formatDateKoedia(this.startDate);
          let availabilityEndDate = this.formatDateKoedia(this.endDate);
          // For event lodgings, checkout date has no availability record (it's the day after the last night),
          // so filter strictly less than checkout date instead of less-than-or-equal.
          let filtered_data = response.data
            .filter((item) => (item.tariff && item.date && item.tariff_price &&
              new Date(item.date) >= new Date(availabilityStartDate) &&
              (this.lodging.event_lodging
                ? new Date(item.date) < new Date(availabilityEndDate)
                : new Date(item.date) <= new Date(availabilityEndDate)))
            );
          if (this.nights > 0) {
            filtered_data = filtered_data.filter(item =>
              item.minimum_nights_stay ? (this.nights >= item.minimum_nights_stay) : true
            );
            // Check if there are multiple tariffs for the same date
            const hasMultipleTariffs = this.hasMultipleTariffsForSameDate(filtered_data);
            // Filter by tariff night requirement (n2, n3, n4, etc.) only if multiple tariffs exist
            filtered_data = filtered_data.filter(item => this.matchesTariffNightRequirement(item, hasMultipleTariffs));
            // For event lodgings, skip the unique-dates-vs-nights check because the checkout date
            // has no availability record in the response (checkout = last night + 1 day).
            if (!this.lodging.event_lodging) {
              // Check if we have availability records for all nights in the date range
              const uniqueDates = [...new Set(filtered_data.map(item => item.date))];
              if ((uniqueDates.length - 1) !== this.nights) {
                filtered_data = [];
              }
            }
          }

          if (filtered_data.length > 0) {
            this.minNightsNew = filtered_data[0].minimum_nights_stay || this.minNightsNew;
          }

          this.availabilitiesNotKoedia = filtered_data.filter((item) => item.tariff_price !== null);
          this.show_resa_card = true;
          this.updateAvailabilityInfo();
        } catch (error) {
          console.error('Error fetching availabilities:', error);
          this.isSearching = false;
        }

        setTimeout(() => {
          this.searched = true;
          this.isSearching = false;
        }, 6000);
      } else {
        // Koedia availability
        this.ReqInventoryBook();
        
        try {
          const response = await this.getAvailability(checkin, checkout, guests);
          this.koediaSessionId = response.data.koedia_session_id;
          this.roomOptions = response.data.availabilities;
          this.show_resa_card = true;
          this.updateAvailabilityInfo();
        } catch (error) {
          this.isSearching = false;
          console.error(error);
        }
      }
    },
    displayUserInfo(...args) {
      const eventName = resolveReservationEventName(this.accommodation_code);
      this.$emit(eventName, ...args);
    },
    openGuestModal() {
      this.$emit('open-guest-modal');
    },
    handleShowModal() {
      this.$emit('show-modal');
    },
    openLoginModal() {
      this.$emit('open-login-modal');
    },
    handleRoomAvailabilityUpdate(hasAvailable) {
      this.hasAvailableRooms = hasAvailable;
    },
    resetAvailability() {
      this.disstartDate = null;
      this.disendDate = null;
      this.arrivalDate = null;
      this.departureDate = null;
      this.startDate = null;
      this.endDate = null;
      this.koediaFrom = null;
      this.koediaTo = null;
      this.from = null;
      this.to = null;
      this.show_resa_card = false;
      this.showReservationCards = false;
      this.availabilitiesNotKoedia = [];
      this.roomOptions = null;
      this.searched = false;
    },
    loadReservationState() {
      const state = JSON.parse(localStorage.getItem('reservationState'));
      if (state && state.from && state.to) {
        this.disstartDate = new Date(this.formatDateKoedia(state.from));
        this.disendDate = new Date(this.formatDateKoedia(state.to));
        this.arrivalDate = this.formatDate2(this.disstartDate);
        this.departureDate = this.formatDate2(this.disendDate);
        this.children = state.childs || 0;
        this.guestNumber = this.adults || 2;
        this.selectedChildAges = Array.isArray(state.children_ages) ? [...state.children_ages] : [];
        this.koediaFrom = state.koediaFrom;
        this.koediaTo = state.koediaTo;
        this.from = state.from;
        this.to = state.to;
        this.startDate = this.formatDate(state.from);
        this.endDate = this.formatDate(state.to);

        // Auto-check availability if dates are present
        this.checkIfAvailable(this.koediaFrom, this.koediaTo, this.guestNumber);
      }
    }
  },
  mounted() {
    // Set accommodation code if available
    if (this.lodging.lodging_channel_manager) {
      this.accommodation_code = this.lodging.lodging_channel_manager.accommodation_code;
    }

    // Set lodging tax
    this.lodgingTax = this.lodging.tax;

    // Set minimum nights
    if (this.lodging.is_entire) {
      this.minNightsNew = this.lodging.availabilities[0]?.minimum_nights_stay;
    }

    // Load state from localStorage if available
    this.loadReservationState();
  },
  watch: {
    isSearching(newVal) {
      this.$emit('searchUpdated', newVal);
    }
  }
};
</script>

<style scoped lang="scss">
.lodgingshow-entire {
  width: 100%;
  
}

.booking-form-container {
  margin-bottom: 30px;
  padding: 19px 36px 20px 38px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #CFE5DC;
  border-radius: 10px;

  @media (max-width: 768px) {
    padding: 15px 20px 15px 20px;
  }
}

@media (max-width: 768px) {
  .villa-lodging-container{
    padding: 10px !important;
  }
}

.reservation-cards-container {
  margin-top: 20px;
  
  .single-column-card {
    width: 100%;
    margin-bottom: 20px;
  }
}

.lodge-info-container {
  height: fit-content;
  background: #CFE5DC99 0% 0% no-repeat padding-box;
  border-radius: 15px;
  opacity: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 20px;
  margin-bottom: 20px;

  @media screen and (max-width: 768px) {
    padding: 15px;
    gap: 10px;
    margin-bottom: 0;
  }
}

.text-green {
  color: #2C5E4B !important;
}

.lodge-info-box {
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(44, 94, 75, 0.2);

  @media screen and (max-width: 768px) {
    border-bottom: unset;
    padding-bottom: 0px;
  }
}

.lodge-info-items {
  gap: 12px;
}

.lodge-info-item {
  align-items: center;
  
  .info-icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
}

@media (max-width: 768px) {
  .booking-form {
    .booking-header {
      .date-selector {
        .date-block {
          margin-bottom: 15px;
          border-right: none;
          
          &:last-child {
            border-bottom: none;
          }

          .value {
            height: 41px;
            border: 0.5px solid #A5D3AE9A;
          }
        }
      }
    }
  }
}

.hortense-btn-disabled {
  background: #2C5E4B;
  opacity: 0.6;
  color: white;
  border: none;
  padding: 16px 36px;
  cursor: not-allowed;
  text-align: center;
  font-weight: bold;
  font-size: 13px;
}

.icon-exclamation {
  width: 10px;
  height: 10px;
  border: 0.5px solid #D56A70;
  opacity: 1;
  border-radius: 50%;

  @media screen and (max-width: 768px) {
    width: 20px;
    height: 12px;
  }
  p {
    width: 2px;
    height: 10px;
    text-align: left;
    font: normal normal medium 8px/24px Raleway;
    letter-spacing: 0px;
    color: #D56A70;
    opacity: 1;
    margin-left: 3px;
  }
}

.link-collapse {
  color: black;
  text-decoration: underline;
  cursor: pointer;
}

.galerie {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000000 0% 0% no-repeat padding-box;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 60px;
  padding: 1rem 2rem;
  color: white;
  width: fit-content;
  height: 34px;

  button {
    font-family: $Raleway;
    font-weight: 500;
    font-size: 13px;
    text-decoration: underline;
    color: black;
    transition: all-ease 1s;
  }
}

.villa-layout-container {
  display: flex;
  gap: 20px;
  width: 100%;
  min-width: 488px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
    min-width: unset;
  }
}

.no-villa-container {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 15px;
  height: fit-content;
  min-height: 210px;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  width: 50%;

  @media (max-width: 768px) {
    padding: 15px;
    width: 100%;
  }

  p {
    text-align: center;
  }
}

.villa-layout-container ::v-deep .villa-info-container {
  flex: 1;
  width: 50%;

  @media (max-width: 768px) {
    width: 100%;
  }
}
</style>
